import { type WebConfig } from '@koala/sdk';
import { readableColor } from 'polished';
import styled from 'styled-components';
import { StyledPrimaryButton } from '@/components/uielements/primaryButton/styles';
import { getFontStyles } from '@/redux/cmsConfig/utils';
import { safePolished } from '@/utils/safePolished';

interface ThemeProps {
  theme: WebConfig;
}

export const StyledReorderListItem = styled.li<{ $visibleDesktopCards?: number }>`
  padding: 17px 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: ${(props: ThemeProps) => props.theme.global.border_radius}px;
  border: 1px solid ${(props: ThemeProps) => props.theme.global.primary_border_color};
  background-color: ${(props: ThemeProps) => props.theme.location_card.background_color};
  list-style-type: none;

  min-width: 265px;
  scroll-snap-align: start;
  width: auto;

  @media (min-width: 768px) {
    margin: 0;
    width: 33.3333%;

    ${({ $visibleDesktopCards }) =>
      $visibleDesktopCards == 2 &&
      `
      min-width: 45%
    `}
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

export const ReorderHeader = styled.header`
  display: flex;
  justify-content: space-between;
`;

export const StyledReorderDate = styled.h3(({ theme }) => ({
  margin: 0,
  fontSize: '14px',
  fontWeight: '800',
  lineHeight: '21px',
  color: theme.buttons.primary_button_background_color,
}));

export const StyledReorderConveyanceLabel = styled.span(({ theme }) => ({
  backgroundColor: theme.buttons.primary_button_background_color,
  borderRadius: `${theme.buttons.primary_button_border_radius}px`,
  fontSize: '11px',
  padding: '3px 10px',
  whiteSpace: 'nowrap',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  ...getFontStyles(theme.buttons.primary_font, ['font_family', 'font_weight', 'color'], {
    color: (value) => {
      if (value === 'revert' || value === null) {
        return safePolished(readableColor)(theme.buttons.primary_button_background_color);
      }

      return value;
    },
  }),
}));

export const StyledReorderLocationLabel = styled.span(({ theme }) => ({
  display: 'block',
  fontSize: '13px',
  ...getFontStyles(theme.location_card.secondary_font, ['font_family', 'color', 'line_height']),
}));

export const StyledReorderMenuItems = styled.p(({ theme }) => ({
  margin: 0,
  fontSize: '13px',
  opacity: 0.7,
  ...getFontStyles(theme.location_card.secondary_font, ['font_family', 'color', 'line_height']),
  '@supports (-webkit-line-clamp: 2)': {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
}));

export const StyledReorderButton = styled(StyledPrimaryButton)`
  margin-top: auto;
  width: 100%;
`;
